const e=({spacing:t,palette:a,vars:o})=>({styleOverrides:{root:{marginBottom:t(3),".Mui-focusVisible":{backgroundColor:((o==null?void 0:o.palette)||a).action.focus}}}});export{e as default};
